import { mapGetters } from 'vuex';
import featureMixin from '@/mixins/featureMixin';
import onboardingMixin from '@/mixins/onboardingMixin';
import { LEADS_TYPES } from '@/views/RenovaDashboard/LeadsParts/constants';

const demoEmails = ['demo@renova.world', 'test98@gmail.com'];
const demoDashBoardData = {
  firstResponseTimeFromSupportTimeLine: [
    {
      dateTime: '2023-08-31T00:00:00.000Z',
      seconds: 10800,
    },
    {
      dateTime: '2023-09-01T00:00:00.000Z',
      seconds: 9600,
    },
    {
      dateTime: '2023-09-02T00:00:00.000Z',
      seconds: 8400,
    },
    {
      dateTime: '2023-09-03T00:00:00.000Z',
      seconds: 7200,
    },
    {
      dateTime: '2023-09-04T00:00:00.000Z',
      seconds: 6000,
    },
    {
      dateTime: '2023-09-05T00:00:00.000Z',
      seconds: 4800,
    },
    {
      dateTime: '2023-09-06T00:00:00.000Z',
      seconds: 3600,
    },
    {
      dateTime: '2023-09-07T00:00:00.000Z',
      seconds: 300,
    },
  ],
  ticketResolutionTimeInsured: {
    minutes: 15,
    percentDiff: 36,
  },
  ticketLeadTotalCount: {
    count: 0,
  },
  ticketResolutionTimeHr: {
    minutes: 300,
    percentDiff: 68,
  },
  ticketCsat: {
    percent: 75,
    percentDiff: 23,
  },
  ticketUnresolvedMoreThanHourCount: {
    count: 9,
  },
  leadsWithoutTasks: { percentDiff: 12, percent: 15 },
  overdueRenewals: { percentDiff: -5, percent: 8 },
  paymentsOverdue: { percentDiff: 3, percent: 4 },
  ticketUnresolvedTotalCount: {
    count: 15,
    percentDiff: -8,
  },
  operatorMetrics: [
    {
      operatorName: 'Natalia Oreiro',
      avatar: 'natalia',
      ticketCsat: {
        percent: 90,
      },
      firstResponseTimeFromSupport: {
        seconds: 2,
      },
      ticketResolutionTimeInsured: {
        minutes: 15,
      },
      ticketResolutionTimeHr: {
        minutes: 30,
      },
      ticketResolutionTotalCount: {
        count: 1,
      },
    },
    {
      operatorName: 'Facundo Arana',
      avatar: 'FacundoArana',
      ticketCsat: {
        percent: 85,
      },
      firstResponseTimeFromSupport: {
        seconds: 5,
      },
      ticketResolutionTimeInsured: {
        minutes: 30,
      },
      ticketResolutionTimeHr: {
        minutes: 60,
      },
      ticketResolutionTotalCount: {
        count: 10,
      },
    },
    {
      operatorName: 'Arturo Maly',
      avatar: 'ArturoMaly',
      ticketCsat: {
        percent: 80,
      },
      firstResponseTimeFromSupport: {
        seconds: 20,
      },
      ticketResolutionTimeInsured: {
        minutes: 48,
      },
      ticketResolutionTimeHr: {
        minutes: 89,
      },
      ticketResolutionTotalCount: {
        count: 7,
      },
    },
    {
      operatorName: 'Norberto Díaz',
      avatar: 'Norberto',
      ticketCsat: {
        percent: 70,
      },
      firstResponseTimeFromSupport: {
        seconds: 50,
      },
      ticketResolutionTimeInsured: {
        minutes: 70,
      },
      ticketResolutionTimeHr: {
        minutes: 120,
      },
      ticketResolutionTotalCount: {
        count: 5,
      },
    },
  ],
  agentMetrics: [
    {
      name: 'Agent 1',
      leadWinCount: { value: 100, percentDiff: 10 },
      leadWinDealPremium: { value: 100000, percentDiff: -10 },
      leadLostCount: { value: 30, percentDiff: 10 },
      leadLostDealPremium: { value: 400, percentDiff: -10 },
      agentComissionTotal: { value: 48000, percentDiff: 5 },
      agentComissionReceived: { value: 30000, percentDiff: 5 },
      agentComissionPending: { value: 18000, percentDiff: 5 },
      firstResponseTime: { value: 720, percentDiff: -5 },
      averageResponseTime: { value: 1200, percentDiff: -5 },
      pipelineCount: 28,
      withoutActivityCount: 3,
      hasConnectedChannel: true
    },
    {
      name: 'Agent 2',
      leadWinCount: { value: 60, percentDiff: 10 },
      leadWinDealPremium: { value: 72000, percentDiff: -10 },
      leadLostCount: { value: 120, percentDiff: 10 },
      leadLostDealPremium: { value: 400, percentDiff: -10 },
      agentComissionTotal: { value: 8900, percentDiff: 5 },
      agentComissionReceived: { value: 8900, percentDiff: 5 },
      agentComissionPending: { value: 0, percentDiff: 5 },
      firstResponseTime: { value: 0, percentDiff: 0 },
      averageResponseTime: { value: 0, percentDiff: 0 },
      pipelineCount: 6,
      withoutActivityCount: 14,
      hasConnectedChannel: false
    }
  ],
  unassignedMetrics: {
    name: 'Unassigned',
    agentUserId: null,
    leadWinCount: { value: 0, percentDiff: 0 },
    leadWinDealPremium: { value: 0, percentDiff: 0 },
    leadLostCount: { value: 1, percentDiff: 0 },
    leadLostDealPremium: { value: 0, percentDiff: 0 },
    agentComissionTotal: { value: 0, percentDiff: 0 },
    agentComissionReceived: { value: 0, percentDiff: 0 },
    agentComissionPending: { value: 0, percentDiff: 0 },
    firstResponseTime: { value: 0, percentDiff: 0 },
    averageResponseTime: { value: 0, percentDiff: 0 },
    pipelineCount: 4,
    withoutActivityCount: 4,
    hasConnectedChannel: false
  },
  salesByInsurer: [
    {
      key: 'gnp', name: 'GNP', premium: 520000, percent: 42, wonCount: 22
    },
    {
      key: 'afirme', name: 'Afirme', premium: 310000, percent: 25, wonCount: 14
    },
    {
      key: 'qualitas', name: 'Qualitas', premium: 215000, percent: 17, wonCount: 9
    },
    {
      key: 'hdi', name: 'HDI', premium: 142500, percent: 11, wonCount: 5
    },
    {
      key: 'allianz', name: 'Allianz', premium: 60000, percent: 5, wonCount: 2
    },
    {
      key: null, name: null, premium: 18000, percent: 1, wonCount: 1
    }
  ],
  salesByProduct: [
    {
      key: 'HEALTH_INSURANCE', name: null, premium: 498000, percent: 40, wonCount: 19
    },
    {
      key: 'LIFE_INSURANCE', name: null, premium: 361000, percent: 29, wonCount: 14
    },
    {
      key: 'AUTO_INSURANCE', name: null, premium: 262000, percent: 21, wonCount: 13
    },
    {
      key: 'HOMEOWNERS_INSURANCE', name: null, premium: 126500, percent: 10, wonCount: 6
    },
    {
      key: null, name: null, premium: 30000, percent: 2, wonCount: 2
    }
  ],
  salesFunnel: [
    {
      stage: 'INCOMING',
      count: 100,
      conversionRate: 100
    }
  ],
  dealPremiumTimeLine: [
    {
      dateTime: '2024-05-13T00:00:00.000Z',
      value: 200
    },
    {
      dateTime: '2024-05-14T00:00:00.000Z',
      value: 300
    }
  ],
  dealPremiumLast7Days: {
    value: 500,
    percentDiff: 10
  },
  dealPremiumLast30Days: {
    value: 1000,
    percentDiff: -2
  },
  sourceOfLead: [
    // Same shape as the metrics endpoint (`name`), so the legend resolves these to
    // leads.options.* instead of falling through to "undefined".
    {
      name: 'WEBSITE',
      percent: 20
    },
    {
      name: 'AGENT',
      percent: 80
    }
  ]
};
const DemoAccountData = {
  computed: {
    ...mapGetters(['user']),
    // Mock/preview data follows the SAME rule as the onboarding placeholder, per hub — there is no
    // separate "demo" condition. A page shows fake data exactly when it shows its onboarding nudge.
    // Service-hub pages (insured, policies, tickets, payments, renewals, plans, carriers, stories,
    // chatbot): preview when there are no policies.
    showServiceDemoData() {
      return this.featureAvailable('demo-dashboard') || this.isServiceHubOnboardingActive;
    },
    // Sales-hub pages (leads + the sales dashboard widgets): preview when there are no leads.
    showSalesDemoData() {
      return this.featureAvailable('demo-dashboard') || this.isSalesHubOnboardingActive;
    },
    // Shared/neutral pages (Tasks, Companies, Clara, dashboard-level): preview only when the account
    // is genuinely empty (no leads AND no policies) — same condition as their shared placeholder.
    // Both counts must be a *known* zero. `null` means the count request has not landed or
    // failed; treating that as empty swaps real data for mock rows on a full account.
    isDemoUser() {
      return this.featureAvailable('demo-dashboard')
        || (this.effectiveLeadCount === 0 && this.effectivePolicyCount === 0);
    },
  },
  mixins: [featureMixin, onboardingMixin],
  data() {
    return {
      demoDashBoardData,
    };
  },
  methods: {},
};
export default DemoAccountData;
